import { EFormTags } from '../../shared/interfaces/form-interfaces';

export const form = [
  {
    id: 'LoginForm',
    items: [
      {
        name: 'email',
        type: 'email',
        label: 'Email',
        tag: EFormTags.textField,
      },
      {
        name: 'password',
        type: 'password',
        label: 'Senha',
        tag: EFormTags.textField,
      },
    ],
  },
];

export const initialData = {
  email: '',
  password: '',
};
